import { ErrorCode, ErrorName } from '../constants/common.constants';

import { BaseError } from './BaseError';

export class UrlSearchParameterNotFoundError extends BaseError {
  constructor({ name }: { name: string }) {
    super(
      `Url parameter (${name}) not found error (Error code: ${ErrorCode.URL_SEARCH_PARAMETER_NOT_FOUND}). Please make sure that you have the correct link.`,
      {
        code: ErrorCode.URL_SEARCH_PARAMETER_NOT_FOUND,
        name: ErrorName.UrlSearchParameterNotFound,
      },
    );
  }
}
